import ProfileFormWrapper from './ProfileFormWrapper.component';

export default ProfileFormWrapper;